// extracted by mini-css-extract-plugin
export default {"root":"lK1MnrZbaAmvK1iXbB7y","fill":"mQlncIjsLvoGoKsxOYaX"};